$(function () {
    var complinkselectors = document.querySelectorAll('.complinkselector');

    complinkselectors.forEach(function (container) {
        var goButton = container.querySelector('.goButton');
        var select = container.querySelector('.comp_link_selector_select');

        if (goButton && select) {
            goButton.addEventListener('click', function () {
                var selectedOption = select.options[select.selectedIndex];
                var linkUrl = selectedOption.value;
                window.location.href = linkUrl;
            });
        }
    });
});